import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import AppContext from "../AppContext";

function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const { i18n } = useTranslation();
  const { darkMode } = useContext(AppContext);

  const languages = [
    {
      label: "English",
      value: "en",
    },
    {
      label: "Italian",
      value: "it",
    },
    {
      label: "Spanish",
      value: "sp",
    },
  ];
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="dropdown dropdown-end flex items-center justify-center relative">
      <button
        onClick={() => setOpen(!open)}
        className=" font-semibold rounded inline-flex items-center bg-inherit border-none hover:bg-inherit"
      >
        <ReactSVG
          src="globe.svg"
          className="md:h-7 md:w-7 h-3 w-3 flex items-center justify-center"
          beforeInjection={(svg) => {
            svg.setAttribute(
              "style",
              `stroke: ${darkMode ? "white" : "black"}`
            );
          }}
        />
        {/* <img src="globe.svg" className="md:h-7 md:w-7 h-3 w-3" alt="Language" /> */}
      </button>
      {open ? (
        <ul
          tabIndex="0"
          className="dropdown-content dropDownProfile menu mt-40 "
        >
          {languages.map((x, index) => (
            <li className="" key={index}>
              <button
                className={`w-32 border-b-0 rounded-t bg-zinc-800 hover:text-white hover:bg-blue-950 py-2 px-4 block whitespace-no-wrap ${
                  i18n.language === x.value ? "text-white" : "text-gray-500"
                }`}
                onClick={() => changeLanguage(x.value)}
              >
                {x.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

export default LanguageSwitcher;
